import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useAuthContext } from "../../hooks/useAuthContext";

// styles
import "./Negocios.css";
// import RESTAURANT from "./img/restaurante.jpg";
// import CASINO from "./img/casinos.jpg";
// import ESTADIO from "./img/estadio.jpg";
// import TRUCK from "./img/truck.jpg";

export default function Negocios() {
  //   const { user, dispatch } = useAuthContext();

  useEffect(() => {
    // document.title = `Rapdis - Negocios`;
  }, []);

  return (
    <div>
      {/* <div className="gallery-image">
        <Link to="/dashboard">
          <div className="img-box">
            <img src={RESTAURANT} />
            <div className="transparent-box">
              <div className="caption colors">
                <p>Restaurantes</p>
              </div>
            </div>
          </div>
        </Link>
        <div className="img-box">
          <img src={TRUCK} />
          <div className="transparent-box">
            <div className="caption colors">
              <p>Carros</p>
            </div>
          </div>
        </div>
        <div className="img-box">
          <img src={ESTADIO} />
          <div className="transparent-box">
            <div className="caption colors">
              <p>Estadios</p>
            </div>
          </div>
        </div>
        <div className="img-box">
          <img src={CASINO} />
          <div className="transparent-box">
            <div className="caption colors">
              <p>Casinos</p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}
